import { ToastService } from 'src/app/base/services/toast.service';
import { Component, OnInit } from '@angular/core';
import { AcodisCategoryDTO, AcodisWorkflowDTO, ApiException, ImportType } from 'src/app/base/models/models.swagger.generated';
import { ImportConfigurationEditFormsCoordinatorService } from '../import-configuration-edit-forms-coordinator.service';
import { AcodisWorkflowService } from '../../../acodis-workflow/acodis-workflow.service';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ImportConfigurationAcodisFormType } from './configuration-form-acodis-form-type';

import { ErrorType } from 'src/app/core/routing/error-types';

@Component({
    selector: 'app-configuration-form-acodis',
    templateUrl: './configuration-form-acodis.component.html',
    styleUrls: ['./configuration-form-acodis.component.scss'],
    imports: [AppErrorMessagesComponent, ReactiveFormsModule, TranslateModule, DropDownListModule]
})

export class ConfigurationFormAcodisComponent implements OnInit {

  public acodisWorkflows: AcodisWorkflowDTO[];

  public acodisCategories: AcodisCategoryDTO[];
  public acodisCategoriesErrorMsg: string;

  public get configurationFormAcodis(): FormGroup<ImportConfigurationAcodisFormType> {
    return this.formsCoordinationService.configurationFormAcodis;
  }
  public fields = { text: 'name', value: 'id' };

  constructor(
    private formsCoordinationService: ImportConfigurationEditFormsCoordinatorService,
    private acodisWorkflowService: AcodisWorkflowService,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.loadAcodisWorkflows();
    this.formsCoordinationService.configurationFormGeneral.controls.importType.valueChanges.subscribe(() => {
      this.loadAcodisWorkflows();
    });

    this.formsCoordinationService.configurationFormAcodis.controls.acodisWorkflowId.valueChanges.subscribe((val) => {
      if (val != null && val != undefined) {
        this.loadAcodisCategories();
      }
    });
  }

  private loadAcodisCategories() {
    this.acodisWorkflowService.getAcodisCategories(this.configurationFormAcodis.controls.acodisWorkflowId.value).subscribe({
      next: (categories) => {
        this.acodisCategories = categories;
        const control = this.configurationFormAcodis.controls.category;
        if (this.acodisCategories.length > 0) {
          if (!control.value) {
            control.setValue(this.acodisCategories[0].id);
          }
          else if (this.acodisCategories.find(x => x.id == control.value) == undefined) {
            control.setValue(this.acodisCategories[0].id);
          }
        }
      },
      error: (error) => {
        if (ApiException.isApiException(error)) {
          try{
            this.acodisCategoriesErrorMsg = JSON.parse(error.response).Message;
            return;
          } catch(e) {

          }
        }
        this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        this.acodisCategoriesErrorMsg = null;
      }
    });
  }

  private loadAcodisWorkflows() {
    const importType: ImportType = this.formsCoordinationService.configurationFormGeneral.controls.importType.value as ImportType;
    if (importType != null) {
      this.acodisWorkflowService.getAllAcodisWorkflowsLimited(importType).subscribe(items => {
        this.acodisWorkflows = items as AcodisWorkflowDTO[];
        if (this.acodisWorkflows.length > 0) {
          if (!this.configurationFormAcodis.controls.acodisWorkflowId.value) {
            this.configurationFormAcodis.controls.acodisWorkflowId.setValue(this.acodisWorkflows[0].id);
          }
          else if (this.acodisWorkflows.find(x => x.id == this.configurationFormAcodis.controls.acodisWorkflowId.value) == undefined) {
            this.configurationFormAcodis.controls.acodisWorkflowId.setValue(this.acodisWorkflows[0].id);
          }
        }
      });
    }
  }
}
